import * as ngCdkOverlay from '@angular/cdk/overlay'
import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'

/**
 * Header for the check-ins page
 */
@ngCore.Component({
  imports: [
    ngCdkOverlay.CdkOverlayOrigin,
    ds.layout.page.child.header.Component,
    ds.button.Component,
    ds.overlay.attached.Component,
    ds.input.search.Component,
  ],
  selector: 'atn-summit-check-ins-header',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.checkIn.Feature} */
  public readonly checkInFeature = ngCore.inject(state.summit.checkIn.Feature)
}
